//@ts-check
import React from 'react';
import { IconInternet } from '../../assets/icons/buttons/IconInternet';
import { IconMail } from '../../assets/icons/buttons/IconMail';
import { IconInstagram } from '../../assets/icons/buttons/IconInstagram';
import { CustomLink } from '../general/CustomLink/CustomLink'; 

/** @type {React.FC<{ links: { url: string }[], className?: string }> } */
export const IconLinks = ({ links, className = '' }) => {
  return (
    <div className={className}>
      {links[0]?.url && links[0].url !== '#' && (
        <CustomLink
          href={links[0].url}
          className="group"
          openInNewWindow={true} 
        >
          <IconInternet
            className=""
            size="40"
            changeColorOnHover={true}
          />
        </CustomLink>
      )}
      {links[1]?.url && links[1].url !== '#' && (
        <CustomLink
          href={links[1].url}
          className="group"
          openInNewWindow={true}
        >
          <IconMail
            className=""
            size="40"
            changeColorOnHover={true}
          />
        </CustomLink>
      )}
      {links[2]?.url && links[2].url !== '#' && (
        <CustomLink
          href={links[2].url}
          className="group"
          openInNewWindow={true}
        >
          <IconInstagram
            className=""
            size="40"
            changeColorOnHover={true}
          />
        </CustomLink>
      )}
    </div>
  );
};